




































































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

import Customer from "@/types/customer/Customer";

import { getFileNameFromLink } from "@/utils/fileName";
import Endpoint from "@/utils/endpoint";
import formatDate, { formatDateWithTime } from "@/utils/formatDate";

interface InvestorDataI extends Customer {
  relations: string;
}

@Component({
  props: ["visible", "investorId"],
})
export default class ModalDetail extends Vue {
  loading = false;
  investorData: any = {};

  statusFormFillColor = {
    "Not Started": "not-started",
    "Filling in": "filling-in",
    Filled: "filled",
  };
  getFileNameFromLink = getFileNameFromLink;
  formatDate = formatDate;
  formatDateWithTime = formatDateWithTime;

  private endpoint = new Endpoint();

  @Watch("investorId")
  async fetchInvestorsSubdocuments(investorId: any) {

    this.loading = true;
    this.investorData = investorId;
    this.loading = false;

  }

  relationShip(investor: Customer): string {
    if (investor && investor.relationships) {
      for (let i = 0; i < investor.relationships.length; i++) {
        if (investor.relationships[i].typeRelationship === 1) {
          return investor.relationships[i].name;
        }
      }
    }

    return "";
  }

  closeModal() {
    this.investorData = {};
    this.$emit("close");
  }
}
